import { useState, useEffect } from 'react';
import DataViewOptions from './DataViewOptions';
import CreateNewDataView from './CreateNewDataView';
import { SHARE_DATA_VIEW } from '../../../../../constants';

type Props = {
  isCreatingNew: boolean;
  actions: any;
  location: any;
  entityType: string;
  filterState: any;
  shareUrl: string;
  dataViewList: any;
  handleChangeDataView: (arg0: string) => void;
  formikProps: any;
  setIsCreatingNew: (arg: boolean) => void;
  history: any;
  inventoriesActions: any;
  createdDataView?: any;
};

function DataViewInputFields({
  isCreatingNew,
  actions,
  location,
  entityType,
  filterState,
  shareUrl,
  dataViewList,
  handleChangeDataView,
  formikProps,
  setIsCreatingNew,
  history,
  inventoriesActions,
  createdDataView,
}: Props) {
  const [triggerRefresh, setTriggerRefresh] = useState(false);
  const [selectedView, setSelectedView] = useState({});
  const [newDataViewName, setNewDataViewName] = useState('');

  const urlParams = new URLSearchParams(location.search);
  const sharedDataViewName = urlParams.get('sharedDataViewName');

  const getSelectLatestDataView = (dataViewList: any) => {
    let selectedViewFiltered = dataViewList.find(
      (dataview: any) => dataview && dataview.key === filterState.dataViewId
    );
    if (!selectedViewFiltered) {
      selectedViewFiltered = dataViewList.find(
        (dataview: any) => dataview && dataview.selected === true
      );
    }
    return selectedViewFiltered || dataViewList[0];
  };

  useEffect(() => {
    if (triggerRefresh && selectedView !== undefined) {
      const { href } = window.location;
      window.history.replaceState('', '', href.substr(0, href.indexOf(SHARE_DATA_VIEW)));
      handleChangeDataView((selectedView as any)?.key);
    }
  }, [selectedView]);

  useEffect(() => {
    setTriggerRefresh(false);

    setSelectedView(getSelectLatestDataView(dataViewList));
  }, [dataViewList]);

  useEffect(() => {
    //Only executed when new dataview is added or is deleted
    if (createdDataView !== undefined) {
      if (
        Object.keys(createdDataView).length !== 0 &&
        createdDataView.latestDataViewId !== (selectedView as any).value
      ) {
        setTriggerRefresh(false);
        handleChangeDataView(createdDataView.key);
      }
      if (createdDataView.filterValues && createdDataView.filterValues.length > 0) {
        handleChangeDataView(createdDataView.key);
      }
    }
  }, [createdDataView]);

  const dataViewOnChange = (e: any, selectedViewId: number) => {
    const selectedViewFiltered = dataViewList.find(
      (dataview: any) => dataview.value === selectedViewId
    );
    setTriggerRefresh(true);
    setSelectedView(selectedViewFiltered);
  };

  let dataViewListFiltered = dataViewList;
  const userDefaultFilterProp = location && location.state && location.state.userDefaultFilterProp;
  if (userDefaultFilterProp && dataViewList) {
    dataViewListFiltered = dataViewList.filter((dv: any) => dv.deletableview === false);
  }

  return !isCreatingNew ? (
    <DataViewOptions
      formikProps={formikProps}
      selectedView={selectedView}
      dataViewOnChange={dataViewOnChange}
      dataViewListFiltered={dataViewListFiltered}
      actions={actions}
      location={location}
      entityType={entityType}
      filterState={filterState}
      shareUrl={shareUrl}
      sharedDataViewName={sharedDataViewName}
      inventoriesActions={inventoriesActions}
      setSelectedView={setSelectedView}
      setIsCreatingNew={setIsCreatingNew}
      setNewDataViewName={setNewDataViewName}
    />
  ) : (
    <CreateNewDataView
      formikProps={formikProps}
      newDataViewName={newDataViewName}
      setIsCreatingNew={setIsCreatingNew}
      actions={actions}
      entityType={entityType}
      filterState={filterState}
      userDefaultFilterProp={userDefaultFilterProp}
      history={history}
    />
  );
}

export default DataViewInputFields;
